import { Outlet } from "react-router-dom";
import {useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";

const GuestLayout = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <div className={theme.palette.mode === "dark" ? "fs-theme fs-guest fs-dark" : "fs-theme fs-guest fs-light"}>
            <header>
                <div className="fs-page-width">
                    <div className="fs-header-logo">
                        <img src="/images/logo_white.png" alt="logo" className="fs-header-logo-large" />
                    </div>
                    <div className="fs-header-menu">
                        header
                    </div>
                </div>
            </header>
            <main>
                <Outlet />
            </main>
        </div>
    );
};
export default GuestLayout;